import { GroupFullSchema } from "./GroupFullSchema";
import { PhoneSchema } from "../../../shared/models/PhoneSchema";

export class InfoGroupDetail {
  key?: string;
  name!: string;
  state!: string;
  description!: string;
  schema!: GroupFullSchema;
  phoneComponentList!: PhoneSchema[];
  dateCreated?: number;
  dateChanged?: number;
}
